
import {Component, Prop, Vue} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';
import {SolarDataLayer} from "../../shared/SolarDataLayer";
import {transformMeasureUnit, showMeasureUnit} from '../../shared/helpers/measure-unit';

@Component({
  name: 'catalog-product-list-item',
  components: ServiceContainer().getComponents(),
})
export default class extends Vue {
  @Prop({required: true}) readonly dataSource: string;
  @Prop({required: true}) readonly product: object;
  @Prop({default: null}) readonly type: string | null;
  @Prop({default: 0}) indexNumber: number;

  @Prop() private readonly imageBaseUrl: string;

  private get listTypeClass(): string {
    switch (this.type) {
      case 'home':
      case 'crosssell':
      case 'last-viewed':
      case 'slider':
        return '';
      default:
        return 'small-12 medium-8';
    }
  }

  private get listComponent(): string {
    switch (this.type) {
      case 'slider':
        return 'div';
      default:
        return 'li';
    }
  }

  private get priceView(): string {
    return this.$store.getters['GlobalSettings/getPriceView'];
  }

  private get transformMeasureUnit(): Function {
    return transformMeasureUnit;
  }

  private get showMeasureUnit(): boolean {
    return showMeasureUnit(this.product['unit_of_measurement']);
  }

  private get productImage(): string {
    if (this.imageBaseUrl) {
      return `${this.imageBaseUrl}/cdn/resize-extended/el:true/rs:fit/w:288/h:288/extend:true/background:255:255:255/path/media/catalog/product${this.product['image']}`;
    }

    return this.product['image'];
  }

  private addProductClick(): void {
    SolarDataLayer.init().addSelectItem({
      ...this.product,
      'item_id': this.product['product_id'],
      'item_group_id': this.product['pim_productfamilie'] || this.product['product_id'],
      'item_variant': '',
      'item_variant_id': this.product['product_id'],
    }, this.indexNumber + 1, 'Product list');
  }

  private mounted(): void {
    this.$forceUpdate();
  }

  private updated(): void {
    this.$eventBus.$emit('item-rendered', true);
  }
}
